import React, { useContext, useState } from "react";
import { get, isEmpty } from "lodash";
import { OverlayTrigger, Tooltip, Row, Col, Form } from "react-bootstrap";

import {
  GetInitials,
  EditActionSlider,
  AddTreeStructure,
  LoaderWrapper,
  SliderPanel,
  DeleteWarning,
} from "../../../components";
import {
  FLOW_TYPES,
  getAdvancedPathWithParam,
  getCommaSeparatedValuesFromArr,
  getFormattedSsn,
  getNullTableItem,
  getPathWithParam,
  LOAN_STATUS,
  MANAGE_CENSUS_ROUTES,
  MANAGE_DISTRIBUTION_ROUTES,
  MANAGE_TRANSACTION_ROUTES,
  ROUTES,
  ssnMasking,
} from "../../../utils";
import AddToolTip from "../../../components/AddToolTip";
// import employeeImage from "../../../assets/sample_image.png";

import { EmployeeStatus } from "../../../layouts";
import { useRequest, useRouterParams, useDeepEffect } from "../../../abstracts";
import {
  getEmployeeImage,
  getCompanyLogo,
  saveInProgressLoanRequest,
  submitLoanRequestById,
  getEmployeeEligiblePlanLoans,
  getLoanSummaryById,
  getEmployeeCensusInformation,
  getAmortizationSchedule,
  getRepaymentSchedule,
} from "../../../services";
import { Link, useHistory } from "react-router-dom";
import ManageTransactionLayout from "../../../components/ManageTransactionLayout/ManageTransactionLayout";
import ManageDistributionLayout from "../../../components/ManageDistributionLayout/ManageDistributionLayout";
import { Formik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import {
  appLayoutStore,
  globalToastInfo,
  manageDistributionStore,
  // manageDistributionStore,
  manageTransactionStore,
  setManageDistributionToastInfo,
  setManageTransactionToastInfo,
  setWithdrawalRequestPageData,
} from "../../../contexts";
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons";
import {
  getInProgressLoan,
  getLoanSummaryDetails,
  getPayrollFrequencies,
} from "../../../services";
import {
  calculateTotalNoOfInstallments,
  getCurrentDateInDDMMYYYY,
} from "../../../utils";
import { useEffect } from "react";
import RejectRequestModal from "./../../../components/RejectRequestModal/RejectRequestModal";
import { approveLoan, rejectLoan } from "./../../../services/transaction/index";
import { CalculateLoanSourceSplit } from "../../Distribution/LoanRequestContainer/CalcuateLoanSourceSplit";
import LoanSummaryDetails from "../../Distribution/LoanSummaryContainer/LoanSummaryDetails";
import LoanModifySummary from "../../Distribution/LoanSummaryContainer/LoanModifySummary";

const source = [
  {
    id: 0,
    head: "Pre-Tax",
    subHead: [
      { name: "Quity", amount: "$900.00" },
      { name: "Mutual Funds", amount: "$900.00" },
    ],
  },
  {
    id: 1,
    head: "After-Tax",
    subHead: [
      { name: "Quity", amount: "$900.00" },
      { name: "Mutual Funds", amount: "$900.00" },
    ],
  },
  {
    id: 2,
    head: "Roth",
    subHead: [
      { name: "Quity", amount: "$900.00" },
      { name: "Mutual Funds", amount: "$900.00" },
    ],
  },
  {
    id: 3,
    head: "Non-Elective",
    subHead: [
      { name: "Quity", amount: "$900.00" },
      { name: "Mutual Funds", amount: "$900.00" },
    ],
  },
  {
    id: 4,
    head: "Non-Elective",
    subHead: [
      { name: "Quity", amount: "$900.00" },
      { name: "Mutual Funds", amount: "$900.00" },
    ],
  },
];

const initialValues = {};

const payrollFrequencyMapper = {
  1: "Daily",
  2: "Weekly",
  3: "SemiMonthly",
  4: "Monthly",
  5: "Quarterly",
  6: "SemiAnnually",
  7: "Annually",
  8: "BiWeekly",
};

const LoanRequestsPendingApprovalContainer = () => {
  const { state, dispatch } = useContext(manageDistributionStore);
  // const filteredValues = get(state, "api.censusInformation", {});
  const { state: state2, dispatch: dispatch2 } = useContext(
    manageTransactionStore
  );
  var today = new Date();
  const history = useHistory();
  const { flow, censusId, loanRequestId, fromPage } = useRouterParams();
  const loanDataFromState = get(state, "loanData");
  const [loanDataFromAPI, setLoanDataFromAPI] = useState({});
  const [planData, setPlanData] = useState({});
  const [responseLoading, setResponseLoading] = useState(false);
  const [loanSettingInfo, setLoanSettingInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState();
  const [show, setShow] = useState(false);
  const [val, setVal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [empName, setEmpName] = useState(null);
  const [isConsentGiven, setIsConsentGiven] = useState(false);
  const [sourceSplit, setSourceSplit] = useState([]);
  const [frequencyList, setFrequencyList] = useState([]);
  const [sourceSplitData, setSourceSplitData] = useState([]);
  const [filteredValues, setFilteredValues] = useState({});
  const [modalToastMsgFor, setModalToastMsgFor] = useState(null);

  function checkBox() {
    setIsConsentGiven(false);
    if (document.querySelector("#opt1:checked")) {
      setIsConsentGiven(true);
    }
    // document.getElementById('msg').innerText = checked;
  }

  useDeepEffect(() => {
    if (filteredValues?.companyId) {
      getPayrollFrequencies(filteredValues?.companyId)
        .then((response) => {
          setFrequencyList(response);
        })
        .catch((error) => {
          //Handle Error
        });
    }
  }, [filteredValues?.companyId]);

  useDeepEffect(() => {
    if (censusId) {
      setResponseLoading(true);
      getEmployeeCensusInformation(censusId)
        .then((response) => {
          setFilteredValues(response);
          setResponseLoading(false);
        })
        .catch((error) => setResponseLoading(false));
    }
  }, [censusId]);

  useDeepEffect(
    () => {
      dispatch(
        setWithdrawalRequestPageData({
          formName: "censusId",
          fieldData: censusId,
        })
      );
    },
    [censusId],
    false
  );

  const payrollFrequencyId = loanDataFromState
    ? loanDataFromState?.repaymentFrequency
    : loanDataFromAPI?.repaymentFrequency;

  const [keyValue, setKeyValue] = useState(1);

  const tabChange = (key) => {
    setKeyValue(key);
  };

  const frequency = frequencyList.find((_, i) => _.id === payrollFrequencyId)
    ?.name;

  const buttonsForApprovalFlow = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_TRANSACTION_ROUTES.PENDINGLOAN,
          })
        ),
    },
    {
      label: "Edit",
      variant: "secondary",
      type: "button",
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_DISTRIBUTION_ROUTES.LOAN_REQUEST,
            pathParam: [FLOW_TYPES.EDIT, censusId, loanRequestId, fromPage],
          })
        ),
    },
    {
      label: "Reject",
      variant: "outline-danger",
      type: "button",
      onClick: () => {
        setShow(true);
      },
    },
    {
      label: "Approve",
      variant: "primary",
      type: "button",
      onClick: () => {
        ApproveLoan();
      },
    },
  ];

  const buttonsForModification = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_TRANSACTION_ROUTES.PENDINGLOAN,
          })
        ),
    },
    {
      label: "Reject",
      variant: "outline-danger",
      type: "button",
      onClick: () => {
        setModalToastMsgFor("Reject");
        setShow(!show);
      },
    },
    {
      label: "Approve",
      variant: "primary",
      type: "button",
      onClick: () => {
        setModalToastMsgFor("Approval");
        setShow(!show);
      },
    },
  ];

  useEffect(() => {
    if (isEmpty(loanDataFromState) && loanRequestId != undefined) {
      setResponseLoading(true);
      getLoanSummaryById(loanRequestId)
        .then((loanResponse) => {
          setAmount(loanResponse?.loanRequest?.requestedAmount);
          if (loanResponse.isSuccessfull) {
            setLoanDataFromAPI(loanResponse["loanRequest"], () => {});
            getEmployeeEligiblePlanLoans(censusId)
              .then((planResponse) => {
                setResponseLoading(false);
                if (planResponse) {
                  var plan = planResponse["employeePlans"].find(
                    (plan) => plan.id == loanResponse["loanRequest"]["planId"]
                  );
                  var loanSetting = plan["loanSettings"].find(
                    (item, index) =>
                      item.masterLoanTypeId ==
                      loanResponse["loanRequest"]?.loanSettingId
                  );
                  setPlanData(plan);
                  var sourceBalances = CalculateLoanSourceSplit(
                    plan?.sourceBalances,
                    loanResponse["loanRequest"],
                    loanSetting,
                    loanResponse["loanRequest"]?.overnightDelivery
                  );
                  setSourceSplitData([
                    {
                      tabName: "Summary",
                      //totalRequestedAmount: 2000,
                      sourceDetails: getSplits(sourceBalances).map(
                        (_) => (_ = { name: _.head, amount: _.amount })
                      ),
                    },
                    ...sourceBalances,
                  ]);
                  setSourceSplit(getSplits(sourceBalances));

                  setLoanSettingInfo(
                    planResponse["employeePlans"]
                      .find(
                        (plan) =>
                          plan.id == loanResponse["loanRequest"]["planId"]
                      )
                      ?.loanSettings?.find(
                        (loanSetting) =>
                          loanSetting.id ==
                          loanResponse["loanRequest"]["loanSettingId"]
                      )
                  );
                }
              })
              .finally(() => {
                // setResponseLoading(false);
              });
          }
        })
        .finally(() => {
          setResponseLoading(false);
        });
    } else setSourceSplit(getSplits(state?.sourceSplit));
  }, []);

  const getSplits = (sourceBalances) => {
    let final = [];
    sourceBalances?.map((source) => {
      let sourceInv = source.sourceInvestmentBalances?.map((inv) => {
        return {
          id: inv.investmentId,
          amount: inv.requestedAmount,
          name: inv.investmentName ?? "-",
        };
      });
      let list = {
        id: source.sourceId,
        head: source.sourceName,
        amount: source.requestedAmount,
        subHead: sourceInv,
      };
      final.push(list);
    });
    return final;
  };

  function getFileNameFromBlobPath(url) {
    return url?.split("/").pop().split("_")[0];
  }

  function getFileExtensionFromBlobPath(url) {
    return url
      ?.split("/")
      .pop()
      .split("_")[1]
      .slice(
        ((url.split("/").pop().split("_")[1].lastIndexOf(".") - 1) >>> 0) + 2
      );
  }
  const onApproveClick = () => {
    setShow(false);
    if (loanStatus == "AwaitingApproval")
      dispatch2(
        setManageTransactionToastInfo({
          showToast: true,
          toastMessage: "Loan request is approved successfully",
          toastMessage2: `The ${loanDataFromAPI.loanType} - ${loanDataFromAPI.loanIdentifier} Loan request is approved.`,
          toastMessage1:
            "Employee Name: " +
            filteredValues.firstName +
            " " +
            filteredValues.lastName +
            " Type -" +
            loanDataFromAPI.loanType +
            " Loan amount" +
            " " +
            amount,
          // reject: true,
        })
      );
    else if (loanStatus == "RefinancingRequestAwaitingApproval")
      dispatch2(
        setManageTransactionToastInfo({
          showToast: true,
          toastMessage: "Loan Refinancing request is approved.",
          toastMessage2: `The ${loanDataFromAPI.loanType} - ${loanDataFromAPI.loanIdentifier} refinancing request is approved.`,
          // toastMessage1:
          //   "Type -" + loanDataFromAPI.loanType + " Loan amount" + " " + amount,
          // reject: true,
        })
      );
    else
      dispatch2(
        setManageTransactionToastInfo({
          showToast: true,
          toastMessage: "Loan Reamortization request is approved.",
          toastMessage2: `The ${loanDataFromAPI.loanType} - ${loanDataFromAPI.loanIdentifier} reamortization request is approved.`,
          // toastMessage1:
          //   "Type -" + loanDataFromAPI.loanType + " Loan amount" + " " + amount,
          // reject: true,
        })
      );

    history.push(
      getPathWithParam({
        path: `${MANAGE_TRANSACTION_ROUTES.PENDINGLOAN}`,
      })
    );
  };

  const ApproveLoan = () => {
    setLoading(true);
    approveLoan(parseInt(loanRequestId))
      .then((response) => {
        if (response) {
          setLoading(false);
          onApproveClick();
        }
      })
      .catch((ex) => {
        setLoading(false);
      });
  };

  const RejectLoan = (boolVal, reasonForRejection, comment, callBack) => {
    setLoading(true);
    rejectLoan({
      loanId: parseInt(loanRequestId, 10),
      reasonForRejection: reasonForRejection,
      comment: comment,
    })
      .then((response) => {
        setLoading(false);
        callBack();
      })
      .catch((ex) => {
        // setLoading(false);
      });
  };

  const onFormSubmit = (values) => {
    const requestId = loanDataFromState?.["loanId"]
      ? loanDataFromState["loanId"]
      : loanRequestId;
    submitLoanRequestById(parseInt(requestId)).then((response) => {
      setResponseLoading(false);
      if (response.isSuccessfull) {
        if (fromPage == 5) {
          dispatch2(
            globalToastInfo({
              showToast: true,
              toastMessage: "Request submitted successfully",
            })
          );
        }

        history.push(
          getAdvancedPathWithParam({
            path:
              fromPage == 5
                ? MANAGE_TRANSACTION_ROUTES.DRAFT
                : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
            pathParam: fromPage == 5 ? [] : [FLOW_TYPES.EDIT, censusId],
          })
        );
      }
    });
  };

  const [sliderOpen1, setSliderOpen1] = useState(false);
  const [employeeImage, setEmployeeImage] = useState("");

  function calculateTotalFees() {
    if (!isEmpty(loanDataFromState)) {
      return (
        loanDataFromState?.loanFeeAmount +
        (loanDataFromState.paymentMethod == 1
          ? loanDataFromState?.chequeFees
          : loanDataFromState?.eftFees)
      );
    } else {
      return (
        loanDataFromAPI?.loanFeeAmount +
        (loanDataFromAPI.paymentMethod == 1
          ? loanDataFromAPI?.chequeFees
          : loanDataFromAPI?.eftFees)
      );
    }
  }

  function calculateNetAmount() {
    return loanDataFromState
      ? loanDataFromState.requestedAmount + calculateTotalFees()
      : loanDataFromAPI.requestedAmount + calculateTotalFees();
  }

  const paymentMethod =
    loanDataFromState?.paymentMethod ?? loanDataFromAPI?.paymentMethod;

  const loanStatus = LOAN_STATUS[loanDataFromAPI?.loanStatus] ?? null;

  const isModified = [
    "RefinancingRequestAwaitingApproval",
    "ReAmortizationRequestAwaitingApproval",
  ].includes(loanStatus);
  console.log("loanstatus", loanStatus);
  console.log("fromstate", loanDataFromState);
  console.log("fromapi", loanDataFromAPI);
  const handleConfirmClick = () => {
    setResponseLoading(true);
    modalToastMsgFor == "Approval"
      ? ApproveLoan()
      : rejectLoan({
          loanId: loanRequestId,
          reasonForRejection: "Deleted",
          comment: "Request Deleted",
        })
          .then((_) => {
            setResponseLoading(false);
            setShow(!show);
            history.push(
              getAdvancedPathWithParam({
                path: MANAGE_TRANSACTION_ROUTES.PENDINGLOAN,
              })
            );
            if (loanStatus == "RefinancingRequestAwaitingApproval")
              dispatch2(
                setManageTransactionToastInfo({
                  showToast: true,
                  toastMessage: "Loan Refinancing request is rejected.",
                  toastMessage2: `The ${loanDataFromAPI.loanType} - ${loanDataFromAPI.loanIdentifier} refinancing request is rejected.`,
                  reject: true,
                })
              );
            else
              dispatch2(
                setManageTransactionToastInfo({
                  showToast: true,
                  toastMessage: "Loan Reamortization request is rejected.",
                  toastMessage2: `The ${loanDataFromAPI.loanType} - ${loanDataFromAPI.loanIdentifier} reamortization request is rejected.`,
                  reject: true,
                })
              );
          })
          .catch((err) => {
            setShow(!show);
            setResponseLoading(false);
          });
  };

  const handleCancelClick = () => {
    setShow(!show);
    setModalToastMsgFor(null);
  };

  const [amortizationSchedule, setAmortizationSchedule] = useState();
  const [repaymentSchedule, setRepaymentSchedule] = useState([]);

  useDeepEffect(() => {
    if (![undefined, null].includes(loanRequestId)) {
      getAmortizationSchedule(loanRequestId)
        .then((res) => {
          setResponseLoading(false);
          setAmortizationSchedule(res);
        })
        .catch((err) => {
          setResponseLoading(false);
        });
      getRepaymentSchedule(loanRequestId)
        .then((res) => {
          setResponseLoading(false);
          setRepaymentSchedule(res);
        })
        .catch((err) => {
          setResponseLoading(false);
        });
    }
  }, [loanRequestId]);

  const principalPaid =
    repaymentSchedule != null
      ? repaymentSchedule
          .map((_) => _.principal)
          .reduce((accumulator, currentValue) => {
            return accumulator + currentValue;
          }, 0)
      : 0;

  return (
    <LoaderWrapper isLoading={responseLoading}>
      <Formik
        initialValues={{}}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          values,
          errors,
          ...rest
        }) => {
          const fieldValues =
            !isEmpty(loanDataFromAPI) && loanRequestId
              ? loanDataFromAPI
              : loanDataFromState;

          console.log("values123", values);

          return (
            fieldValues && (
              <Form onSubmit={handleSubmit}>
                <ManageTransactionLayout
                  buttons={
                    !isModified
                      ? buttonsForApprovalFlow
                      : buttonsForModification
                  }
                  // buttons={
                  //   (fromPage == 1 || fromPage == 5)? buttonsForApprovalFlow

                  //     : !isEmpty(loanDataFromState)
                  //     ? buttonsForInprogress
                  //     : buttonsForAwatingForApproval
                  // }
                  layoutHeader={
                    !isModified
                      ? "Loan Request"
                      : "Loan modification pending approval"
                  }
                  //filteredValues={filteredValues}
                  isLoanSummary={true}
                  blockNavigation={true}
                  employeeImage={employeeImage}
                >
                  {!isModified ? (
                    <LoanSummaryDetails
                      keyValue={keyValue}
                      paymentMethod={paymentMethod}
                      tabChange={tabChange}
                      fieldValues={fieldValues}
                      loanData={fieldValues}
                      planData={planData}
                      loanSettingInfo={loanSettingInfo}
                      filteredValues={filteredValues}
                      loanDataFromState={loanDataFromState}
                      checkBox={checkBox}
                      setSliderOpen1={setSliderOpen1}
                      errors={errors}
                      today={today}
                      loanStatus={loanStatus}
                      sourceSplit={sourceSplit}
                      sourceSplitData={sourceSplitData}
                      calculateTotalFees={calculateTotalFees}
                      calculateNetAmount={calculateNetAmount}
                      principalPaid={principalPaid}
                      isModified={isModified}
                      setResponseLoading={setResponseLoading}
                      amortizationSchedule={amortizationSchedule}
                      repaymentSchedule={repaymentSchedule}
                    />
                  ) : (
                    <LoanModifySummary
                      keyValue={keyValue}
                      paymentMethod={paymentMethod}
                      tabChange={tabChange}
                      fieldValues={fieldValues}
                      loanData={fieldValues}
                      planData={planData}
                      loanSettingInfo={loanSettingInfo}
                      filteredValues={filteredValues}
                      loanDataFromState={loanDataFromState}
                      checkBox={checkBox}
                      setSliderOpen1={setSliderOpen1}
                      errors={errors}
                      today={today}
                      loanStatus={loanStatus}
                      principalPaid={principalPaid}
                      sourceSplit={sourceSplit}
                      sourceSplitData={sourceSplitData}
                      calculateTotalFees={calculateTotalFees}
                      calculateNetAmount={calculateNetAmount}
                      isModified={isModified}
                      fromApproval={true}
                    />
                  )}
                </ManageTransactionLayout>
                {!isModified ? (
                  <RejectRequestModal
                    show={show}
                    setShow={setShow}
                    setVal={setVal}
                    history={history}
                    amount={amount}
                    RejectLoan={RejectLoan}
                    loanType={loanDataFromAPI?.loanType}
                    empName={
                      filteredValues.firstName + " " + filteredValues.lastName
                    }
                  />
                ) : (
                  <DeleteWarning
                    showModal={show}
                    DeleteToastMessage={`Are you sure you want to ${
                      modalToastMsgFor == "Approval" ? "approve" : "reject"
                    } the Loan modification request?`}
                    handleConfirmClick={handleConfirmClick}
                    handleCancelClick={handleCancelClick}
                    cancelButtonText={"No"}
                    removeButtonText={"Yes"}
                    isApproval={true}
                  />
                )}
              </Form>
            )
          );
        }}
      </Formik>
    </LoaderWrapper>
  );
};
export default LoanRequestsPendingApprovalContainer;
